import { knownBackgroundColors } from './index';

export const DEFAULT_GRAY_COLOR = knownBackgroundColors[10];
